<template>
  <v-avatar :color="color" :size="size">
    <img v-if="imageSrc" :src="imageSrc" :alt="altText" />
    <span v-else class="white--text text-caption font-weight-medium">
      {{ fallbackTextValue }}
    </span>
  </v-avatar>
</template>

<script>
import { getGraphPhotoObjectUrl } from "../services/graphPhotoCache";

export default {
  name: "GraphPhotoAvatar",
  props: {
    photoUrl: {
      type: String,
      default: "",
    },
    fallbackText: {
      type: String,
      default: "?",
    },
    color: {
      type: String,
      default: "#006c27",
    },
    size: {
      type: [Number, String],
      default: 28,
    },
    altText: {
      type: String,
      default: "owner avatar",
    },
  },
  data() {
    return {
      imageSrc: null,
      loadRequestId: 0,
    };
  },
  computed: {
    fallbackTextValue() {
      const normalized = (this.fallbackText || "").trim();
      return normalized === "" ? "?" : normalized;
    },
  },
  watch: {
    photoUrl: {
      immediate: true,
      handler() {
        this.loadPhoto();
      },
    },
  },
  methods: {
    async loadPhoto() {
      const requestId = ++this.loadRequestId;
      this.imageSrc = null;

      const normalizedPhotoUrl = (this.photoUrl || "").trim();
      if (normalizedPhotoUrl === "") {
        return;
      }

      try {
        const objectUrl = await getGraphPhotoObjectUrl(
          normalizedPhotoUrl,
          this.$authService
        );
        if (requestId !== this.loadRequestId) {
          return;
        }
        this.imageSrc = objectUrl;
      } catch (error) {
        if (requestId !== this.loadRequestId) {
          return;
        }
        this.imageSrc = null;
      }
    },
  },
};
</script>
